import { Option, none, isNone, some, isSome } from 'fp-ts/lib/Option';
import { UpdateDashboardCriteria } from 'use-case/dashboard/update/updateDashboardCriteria';

export interface UpdateDashboardNameCriteria extends UpdateDashboardCriteria {
    name: string;
    description: string;
}

class UpdateDashboardNameCriteriaImpl implements UpdateDashboardNameCriteria {
    constructor(readonly id: string, readonly name: string, readonly description: string) {}
}

export class UpdateDashboardNameCriteriaBuilder {
    private id: Option<string> = none;

    private name: Option<string> = none;

    private description: Option<string> = none;

    static create = (): UpdateDashboardNameCriteriaBuilder => new UpdateDashboardNameCriteriaBuilder();

    withId = (id: string): UpdateDashboardNameCriteriaBuilder => {
        this.id = some(id);
        return this;
    };

    withName = (name: string): UpdateDashboardNameCriteriaBuilder => {
        this.name = some(name);
        return this;
    };

    withDescription = (description: string): UpdateDashboardNameCriteriaBuilder => {
        this.description = some(description);
        return this;
    };

    build = (): UpdateDashboardNameCriteria => {
        if (isNone(this.id) || isNone(this.name)) {
            throw new ReferenceError('Undefined prop');
        }

        return new UpdateDashboardNameCriteriaImpl(this.id.value, this.name.value, isSome(this.description) ? this.description.value : '');
    };
}
